import {booleanAttribute, ChangeDetectionStrategy, Component, input} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-asset-cell-chip",
    templateUrl: "./asset-cell-chip.component.html",
    styleUrls: ["./asset-cell-chip.component.scss"],
    host: {
        "[class.cm-interactive]": "$interactive()",
    },
})
export class AssetCellChipComponent {
    readonly $interactive = input(false, {alias: "interactive", transform: booleanAttribute})
}
